import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';
import cn from 'classnames';
import styles from './Button.module.css';
import { ReactComponent as SpinnerIcon } from './Spinner.svg';

type Props = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
    appearance: 'primary' | 'ghost';
    isLoading?: boolean;
    rightIcon?: SVGSVGElement | React.ReactElement;
};

const Button = ({ appearance, rightIcon, isLoading, ...props }: Props) => {
    return (
        <button {...props} className={cn(styles.button, styles[appearance], props.className)}>
            <>
                <span>{props.children}</span>
                {isLoading ? <SpinnerIcon className={styles.spinner} /> : rightIcon}
            </>
        </button>
    );
};

export default Button;
